import { defineComponent, ref, reactive, computed, PropType } from 'vue';
import { FilterSelectionCompanions } from '@Types/FilterSelections';
import AmountPicker from '@Components/AmountPicker/AmountPicker.vue';
//import { defaultSearchDefinitions } from '@Types/DefaultSearchDefinitions';
import appTranslations from "@Components/CompanionsPicker/Translations/VueTranslations"

export default defineComponent({

    components: { AmountPicker },

    props: {

        model: Object as PropType<FilterSelectionCompanions>,

        // todo: add prop to determine what guest info should be shown or not
        maxPets: {
            type: Number,
            default: 3
        },
        maxGuests: {
            type: Number,
            default: 45 // note this number currently defines the max value used in the vue pickers. and is not dynmamically set from the actual max number currently available.
        },
        customButtonText: {
            type: String,
            default: appTranslations.companionsPicker_Button_CustomButton
        },

        hideChrome: Boolean,

        // introduced with searchbar 2023,
        // the old version had no btn type, and was considered a submit
        // btn when in a form, thus automatically submitting the form.
        // in 2023, we should trigger a specific submit action and
        // perform the logic.
        forceNoBtnType: {
            type: Boolean,
            default: false
        }
    },

    emits: {

        guestsConfirmed: null
    },

    setup(props, context) {

        

        const onConfirm = (e: Event) => {

            context.emit("guestsConfirmed");
        };



        return {

            //defaultSearchDefinitions,
            onConfirm,
            forceNoBtnType: props.forceNoBtnType,
            companionsPicker_Title_ChooseCompany: appTranslations.companionsPicker_Title_ChooseCompany,
            companionsPicker_Label_NumberOfBabies: appTranslations.companionsPicker_Label_NumberOfBabies,
            companionsPicker_Label_NumberOfPersons: appTranslations.companionsPicker_Label_NumberOfPersons,
            companionsPicker_Label_NumberOfPets: appTranslations.companionsPicker_Label_NumberOfPets,
            companionsPicker_Title_Between_0_2_years: appTranslations.companionsPicker_Title_Between_0_2_years

        };

    }



});
